
import findAncestorWithAttr from '../Utils/findAncestorWithAttr';

export default class LifeRecommendationQuoteHandler {
    constructor(data) {
        this.data = data;

        this.formId = "life-recommendation-form";
        this.hasPropertyLoanRadioId = "life-recommendation-form__has-loan";
        this.hasNoPropertyLoanRadioId = "life-recommendation-form__has-no-loan";

        this.form = document.getElementById(this.formId);
        this.hasPropertyLoanRadio = document.getElementById(this.hasPropertyLoanRadioId);
        this.hasNoPropertyLoanRadio = document.getElementById(this.hasNoPropertyLoanRadioId);

        this.recommendationHolderId = 'recommendation-holder';
        this.recommendationHolder = document.getElementById(this.recommendationHolderId);

        this.accordionBodyAttr = 'data-lf-accordion-body';

        this.initialize();
    }

    initialize() {

        this.addEventListeners();
    }

    formatNumber(string, times) {
        if (!times)
            times = 1;
        return (parseInt(string) * times).toLocaleString('sv');
    }

    calculate(data) {
        let salary = data.get('salary');
        let loan = data.get('loan');
        const hasChildren = data.get('has_children') == "true";
        const hasLoan = data.get('has_loan') == "true";

        let amount = 0;

        this.recommendationHolder.innerHTML = "";

        if (salary.length == 0) {
            return;
        } else {
            salary = salary.replace(/[^0-9]/g, '');

            if (salary.length == 0) {
                return;
            }
        }

        if (loan) {
            loan = loan.replace(/[^0-9]/g, '');
        }


        amount += parseInt(salary) * 12;

        if (hasChildren) {
            amount *= 2;
        }

        if (loan) {
            amount += parseInt(loan);
        }

        const div = document.createElement('div');

        const h3 = document.createElement('h3');
        const p = document.createElement('p');
        const pp = document.createElement('p');
        const ppp = document.createElement('p');
        const pppp = document.createElement('p');
        const ppppp = document.createElement('p');

        const childP = document.createElement('p');

        const a = document.createElement('a');

        let loanPart = hasLoan && loan && !isNaN(parseInt(loan)) ? "din totala andel av bolån är " + this.formatNumber(loan) + " kr och att " : "";

        h3.innerText = "Vilket livförsäkringsbelopp ska jag välja?";

        p.innerText = "Du har angivit att " + loanPart + "du har en årslön på " + this.formatNumber(salary, 12) + " kr före skatt" + (hasChildren ? ' samt att du har barn' : '') + ".";

        pp.innerText = "Syftet med en livförsäkring kan sägas vara att hjälpa de som är ekonomiskt beroende av dig att hantera de ekonomiska följderna om du skulle gå bort. Exempelvis mot att stå ensam kvar med ett bolån eller utan en ytterligare inkomst.";

        ppp.innerHTML = "Vilket livförsäkringsbelopp du ska välja beror på din ekonomiska situation, hur din livssituation ser ut och vilka behov du tror att dina efterlevande kommer att ha.";

        pppp.innerText = "Några ytterligare faktorer som du kan ta hänsyn till när du väljer livförsäkringsbelopp är bland annat hur många barn du har, hur stora lån du och din partner har och vilka andra ekonomiska tillgångar du har enligt följande:";

        a.href = "tel:0771210909";
        a.innerText = "0771-21 09 09";

        ppppp.innerText = "Är du fortfarande osäker på vilket livförsäkringsbelopp du ska välja? Kontakta en kundrådgivare på telefon ";
        ppppp.appendChild(a);

        const finalSpan = document.createElement('span');
        finalSpan.innerText = " så hjälper de dig med hur du kan tänka för att räkna ut ett belopp som passar din livssituation.";

        ppppp.appendChild(finalSpan);

        // List
        const ul = document.createElement('ul');

        const listItems = [
            "En person med stora bolån som en efterlevande partner måste ta över för att kunna bo kvar i sin bostad kan behöva ett högre livförsäkringsbelopp än en person som inte har sådana lån.",
            "En person som står för en stor andel av hushållets inkomster varje månad kan behöva ett högre livförsäkringsbelopp än den som står för en relativt liten andel av hushållets inkomster.",
            "En person som har andra ekonomiska tillgångar kan klara sig med ett lägre livförsäkringsbelopp än den som saknar sådana tillgångar."
        ];

        listItems.forEach(str => {
            const li = document.createElement('li');
            li.innerText = str;
            ul.appendChild(li);
        });

        childP.innerText = "En person med små barn kan behöva ett högre livförsäkringsbelopp än en person utan barn, eller en person med vuxna barn som har flyttat hemifrån och försörjer sig själva.";

        div.append(h3);

        div.append(p);
        div.append(pp);
        div.append(ppp);
        if (hasChildren) {
            div.append(childP);
        }
        div.append(pppp);
        div.append(ul);
        div.append(ppppp);

        this.recommendationHolder.append(div);

        let accordionBody = findAncestorWithAttr(this.form, this.accordionBodyAttr);
        let outerAccordionBody = findAncestorWithAttr(accordionBody, this.accordionBodyAttr);

        accordionBody.style.maxHeight = accordionBody.scrollHeight + 'px';
        setTimeout(() => {
            outerAccordionBody.style.maxHeight = outerAccordionBody.scrollHeight + 'px';
        }, 300);
    }

    addEventListeners() {
        const that = this;

        if (this.form) {
            this.hasPropertyLoanRadio.addEventListener('change', (e) =>
                this.form.classList.toggle('show-loan', e.currentTarget.checked)
            );

            this.hasNoPropertyLoanRadio.addEventListener('change', (e) => {
                this.form.classList.toggle('show-loan', !e.currentTarget.checked)
            });

            this.form.addEventListener('submit', (e) => {
                e.preventDefault();
                that.calculate(new FormData(e.target));
            });
        }
    }
}